import React, { useLayoutEffect, useState } from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import ProfilePicture from '../assets/images/profile_picture_linkedin.jpg';
import bgDark from '../assets/images/bg-dark.png';
import bgLight from '../assets/images/bg-light.png';
import '../assets/styles/Main.scss';

function Main() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const rootEl = document.querySelector('.main-container');
    return rootEl?.classList.contains('dark-mode');
  });

  useLayoutEffect(() => {
    const target = document.querySelector('.main-container');
    if (!target) return;

    const updateTheme = () => {
      setIsDarkMode(target.classList.contains('dark-mode'));
    };

    updateTheme();

    const observer = new MutationObserver(updateTheme);
    observer.observe(target, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);

  const backgroundStyle = {
    backgroundImage: `url(${isDarkMode ? bgDark : bgLight})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'scroll',
  };

  return (
      <div className="container">
        <div className="about-section" style={backgroundStyle}>
          <div className="image-wrapper">
            <img src={ProfilePicture} alt="Avatar" />
          </div>
          <div className="content">
            <div className="social_icons">
              <a href="https://github.com/EsraBen" target="_blank" rel="noreferrer"><GitHubIcon /></a>
              <a href="https://www.linkedin.com/in/esra-jemni-206741200/" target="_blank" rel="noreferrer"><LinkedInIcon /></a>
            </div>
            <h1>Esra Ben Hedi Jemni</h1>
            <p>DevOps Engineer</p>
            <div className="mobile_social_icons">
              <a href="https://github.com/EsraBen" target="_blank" rel="noreferrer"><GitHubIcon /></a>
              <a href="https://www.linkedin.com/in/esra-jemni-206741200/" target="_blank" rel="noreferrer"><LinkedInIcon /></a>
            </div>
          </div>
        </div>
      </div>
  );
}

export default Main;
